import { Order } from 'api/rates/rates.types';
import { PAGINATION_ROWS } from 'pages/rates/components/RatesTable/RatesTable.consts';

export const DEFAULT_PARAMS = {
  pageNumber: 1,
  resultSize: PAGINATION_ROWS[0],
  sortProperty: 'rateNumber',
  sortDirection: 'desc' as Order,
  filterText: '',
  onlyMine: false,
};
